var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11V3.5H11V11H3.5ZM5 9.5H9.5V5H5V9.5ZM3.5 20.5V13H11V20.5H3.5ZM5 19H9.5V14.5H5V19ZM13 11V3.5H20.5V11H13ZM14.5 9.5H19V5H14.5V9.5ZM18.625 20.5V18.625H20.5V20.5H18.625ZM13 14.875V13H14.875V14.875H13ZM14.875 16.75V14.875H16.75V16.75H14.875ZM13 18.625V16.75H14.875V18.625H13ZM14.875 20.5V18.625H16.75V20.5H14.875ZM16.75 18.625V16.75H18.625V18.625H16.75ZM16.75 14.875V13H18.625V14.875H16.75ZM18.625 16.75V14.875H20.5V16.75H18.625Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.85495069456738d84b5bba01afc07c95.svg";
export { ForwardRef as ReactComponent };